import React from 'react';

import type { Grant } from '../types';

interface Props {
  grant?: Grant;
}

export default function NylasGrantStatus({ grant }: Props) {
  if (!grant) {
    return null;
  }

  return (
    <span className="fs-small">
      <span className="text-muted">Connected with: {grant.email}</span>
      {grant.expired && <span className="text-danger"> (expired)</span>}
    </span>
  );
}
